import React, { useState, useEffect } from 'react';
import { ArrowRight, Target, Globe, Brain, FileText, TrendingUp, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import StorySection from '../components/StorySection';
import FounderSection from '../components/FounderSection';
import ProblemSection from '../components/ProblemSection';
import ServicesSection from '../components/ServicesSection';
import VisionSection from '../components/VisionSection';
import ManifestoSection from '../components/ManifestoSection';
import ProfileSection from '../components/ProfileSection';
import ApplicationSection from '../components/ApplicationSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToApplication = () => {
    const applicationSection = document.getElementById('application');
    if (applicationSection) {
      applicationSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="landing-page">
      <Header />
      <HeroSection onCtaClick={scrollToApplication} />
      <StorySection id="story" />
      <FounderSection />
      <ProblemSection />
      <ServicesSection id="services" />
      <VisionSection />
      <ManifestoSection id="manifesto" />
      <ProfileSection />
      <ApplicationSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
